/**
 * Handle enquiry form submissions and add field values to Google
 * dataLayer for enhanced conversions.
 */

function handleEnquiryFormConversions(
    form,
    eventName,
    appendType = true,
    mappings = {
        email: 'real_email',
        name: 'name',
        telephone: 'telephone',
        type: 'type',
    },
) {
    if (window.dataLayer) {
        const type = form.find('select[name="' + mappings.type + '"]').val();
        const data = {
            customerCountry: '',
            customerPostcode: '',
            event: appendType ? eventName + '_' + type : eventName,
        };

        const customerEmail = form.find('input[name="' + mappings.email + '"]').val();
        if (customerEmail) {
            data.customerEmail = customerEmail;
        }

        const customerTelephone = form.find('input[name="' + mappings.telephone + '"]').val();
        if (customerTelephone) {
            data.customerTelephone = customerTelephone;
        }

        const name = form.find('input[name="' + mappings.name + '"]').val();
        if (name) {
            const nameParts = name.split(/\s/);
            const customerFirstName = nameParts[0];
            const customerLastName = nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';
            data.customerFirstName = customerFirstName;
            data.customerLastName = customerLastName;
        }

        dataLayer.push(data);
    }
}

jQuery('#enquiry-specific form').submit(function() {
    handleEnquiryFormConversions(jQuery(this), 'specific_enquiry', true);
    return true;
});

jQuery('#enquiry form').submit(function() {
    handleEnquiryFormConversions(jQuery(this), 'general_enquiry', false);
    return true;
});

jQuery('form#contact').submit(function() {
    handleEnquiryFormConversions(jQuery(this), 'contact', false);
    return true;
});

jQuery('body.create.review form').submit(function() {
    handleEnquiryFormConversions(
        jQuery(this),
        'create_your_own_enquiry',
        false,
        mappings = {
            email: 'email',
            name: 'name',
            telephone: 'telephone',
            type: 'type',
        },
    );
    return true;
});
